<template>
  <v-btn-toggle mandatory style="width: 100%">
    <v-btn
      large
      v-for="item in items"
      :key="item.status"
      @click="setGroupOriginBetValue(item.value)"
      style="flex: 1"
    >
      {{ item.text }}
    </v-btn>
  </v-btn-toggle>
</template>
<script>
export default {
  name: "components-common-filters-group-status",
  data: () => ({}),
  computed: {
    items() {
      return [
        { text: this.$t("all"), value: "todos" },
        { text: this.$t("terminal"), value: "terminal" },
        { text: this.$t("agents"), value: "agentes" },
      ];
    },
  },
  methods: {
    setGroupOriginBetValue(value) {
      this.$store.commit("setGroupOriginBetValue", value);
    },
  },
};
</script>
